// src/pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-naim-app p-6 text-emerald-50">
      <div className="rounded-2xl border border-emerald-400/20 bg-emerald-900/40 p-8 text-center">
        <h1 className="text-2xl font-semibold mb-2">404 — Not Found</h1>
        <p className="text-emerald-200/70 mb-4">The page you’re looking for doesn’t exist.</p>
        <Link
          to="/"
          className="inline-block rounded-xl bg-emerald-900 px-4 py-2 text-sm ring-1 ring-emerald-400/20 hover:bg-emerald-800"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
